import PropTypes from 'prop-types';
import { ProviderStatus } from '../components';
import { ConditionalSharedCarrierStatus } from '../shared-carrier-status';
import { ConditionalPackingSlipProvider } from '../shared-packing-slips-status';
import { PendingProviderPropType, ProviderPropType } from '../types';
import { VendorActionsMenu } from './vendor-actions-menu';
import { vendorColumns } from './vendor-columns';

const NameComponent = ({ provider }) => provider?.partnerName;

const EmailComponent = ({ provider }) => provider?.partnerEmail;

NameComponent.propTypes = {
  provider: PropTypes.oneOfType([PendingProviderPropType, ProviderPropType]).isRequired,
};

EmailComponent.propTypes = NameComponent.propTypes;

const VendorFactory = {
  [vendorColumns.NAME]: NameComponent,
  [vendorColumns.EMAIL]: EmailComponent,
  [vendorColumns.STATUS]: ProviderStatus,
  [vendorColumns.SHARED_SERVICES]: ConditionalSharedCarrierStatus,
  [vendorColumns.PACKING_SLIP_SHARING]: ConditionalPackingSlipProvider,
  [vendorColumns.ACTIONS]: VendorActionsMenu,
};

export default VendorFactory;
